import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    name: "RecordingList",
    components:{Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            recordingList:[],
            singleCastList:{},
            castList: [],
            publisherList:[],
            authorList: [],
            vocalArtist:[],
            authorName:[],
            b_name: undefined,
            date: undefined,
            time: undefined,
        }
    },
    async created() {
        await this.getAll();
        await this.getCast();
        await this.getAuthorList();
    },
    methods: {

        async getAll() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version1 +
                    "/audiobooks/castcrew/getall",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                //console.log(res)
                if (res.status === 200) {
                    //console.log(res.data.data)
                    this.recordingList = res.data.data
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async getCast() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/getall",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status === 200) {
                this.castList = res.data.data.map((el) => {
                    return el.name;
                });
                this.isLoading = false;
            }
        },
        async getAuthorList() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/audiobooks/authors/getall",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status === 200) {
                this.authorList = res.data.data.map((el) => {
                    return el.name;
                });
                this.isLoading = false;
            }
        },
        async getSingle(id) {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version1 +
                    "/audiobooks/castcrew/findById?id="+ id,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    //console.log(res.data.data)
                    this.singleCastList = res.data.data[0]
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        onImageChange(event) {
            this.files = event.target.files[0];
        },
        async addRecording() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
            const formData = new FormData();
            formData.append("name", this.name);
            formData.append("en_name", this.enName);
            formData.append("description", this.description);
            formData.append("files", this.files);
            const res = await axios.post(
                this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/addCastCrew",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            this.isLoading = false;
            if (res.status === 201 || res.status === 200) {
                this.isLoading = false;
                document.getElementById('add_btn_close').click();
                this.$swal.fire({
                    icon: "success",
                    title: "create Cast and crew successfully",
                })
                this.name = '';
                this.description = '';
                this.files = undefined;
                await this.getAll();

            } else {
                this.isLoading = false;
                this.$vToastify.error("Could not create Cast and crew");
            }
        } catch (error) {
            console.log(error);
          this.isLoading = false;
            this.$swal.fire({
                icon: "error",
                text: "An error occurred!"
            });
        }
        },
        async update(e) {
            this.isLoading = true;
            if (this.files === undefined || this.files === "" || this.files === null){
                await this.updateWithoutImage(e);
            } else {
                await this.updateWithImage(e);
            }
        },
        async updateWithImage(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("id", this.singleCastList.id);
                formData.append("name", this.singleCastList.name);
                formData.append("en_name", this.singleCastList.en_name);
                formData.append("description", this.singleCastList.description);
                formData.append("files", this.files);
                formData.append("isActive", this.singleCastList.isActive);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/updateCastCrewById",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    this.isLoading = false;
                    document.getElementById('edit_btn_close').click();
                    this.$swal.fire({
                        icon: "success",
                        title: "Cast and crew Update successfully",
                    })
                    this.files = null;
                    e.target.reset()
                    await this.getAll()

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Could not create Cast and crew");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async updateWithoutImage(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                let data = {
                    'id': this.singleCastList.id,
                    'name': this.singleCastList.name,
                    'en_name': this.singleCastList.en_name,
                    'description': this.singleCastList.description,
                    'imageUrl': this.singleCastList.imageUrl,
                    'isActive': this.singleCastList.isActive,
                }
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/updateCastCrewById",
                    JSON.stringify(data),
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    this.isLoading = false;
                    document.getElementById('edit_btn_close').click();
                    this.$swal.fire({
                        icon: "success",
                        title: "Cast and crew Update successfully",
                    })
                    this.files = null;
                    e.target.reset()
                    await this.getAll()

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Could not create Cast and crew");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        updateStatus: async function (event, index, data, isActiveStatus) {
            let isActiveValue
            if(event.target.checked === false){
                isActiveValue = 0
            }
            if (event.target.checked === true){
                isActiveValue = 1
            }

             console.log(data);
            this.$swal.fire({
                title: 'Are you sure?',
                text: "Are you sure to update this data?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const token = localStorage.getItem(this.$tokenKey);
                        const res = await axios.post(
                            this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/updateCastCrewById",
                            {
                                id: data.id,
                                name: data.name,
                                en_name: data.en_name,
                                imageUrl: data.imageUrl,
                                description: data.description,
                                isActive: isActiveValue,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        this.isLoading = false;
                        if (res.status === 200 || res.status === 201 ) {
                            await this.getAll();
                        }
                    } catch (error) {
                        console.log(error);
                        await this.getAll();
                        this.$swal.fire({
                            icon: "error",
                            text: "An error occurred!"
                        });
                    }
                } else {
                    this.castList[index].isActive = isActiveStatus
                }
            })
        },
    },
}
